import { errors } from "@shared/errors";
import { PartialI18nLocale } from "../types";

export const thLocale: PartialI18nLocale = {
  identity: { name: "ภาษาญี่ปุ่น", flag: "🇹🇭" },

  command: {
    accept: "ยอมรับ",
    acceptWhat: "ยอมรับ{{what}}",
    clear: "ล้าง",
    closeWhat: "ปิด{{what}}",
    confirmWhat: "ยืนยัน{{what}}",
    editWhat: "เปลี่ยนแปลง{{what}}",
    logIn: "เข้าสู่ระบบ",
    logOut: "ออกจากระบบ",
    openWhat: "เปิด{{what}}",
    reject: "ปฏิเสธ",
    rejectWhat: "ปฏิเสธ{{what}}",
    resetWhat: "รีเซ็ต{{what}}",
    requestWhat: "ขอ{{what}}",
    save: "บันทึก",
    search: "ค้นหา",
    selectWhat: "เลือก{{what}} ",
    sendWhat: "ส่ง{{what}} ",
    sendingWhat: "กำลังส่ง{{what}} ",
    setWhat: "ตั้งค่า{{what}} ",
    toggleWhat: "สลับ{{what}}",
  },

  dashboard: {
    accepted: "ยอมรับแล้ว",
    acceptedPercent: "ยอมรับแล้ว {{percent}}%",
    acceptedRejectedDetail: "ยอมรับแล้ว {{accepted}} รายการ, ปฏิเสธ {{rejected}} รายการ",
    acceptedRejectedIn: "อัตราการยอมรับใน {{month}}",
    acceptanceRate: "อัตราการยอมรับ",
    acceptanceLastDays: "อัตราการยอมรับใน {{count}} วันที่ผ่านมา",
    acceptanceLast30Days: "อัตราการยอมรับใน 30 วันที่ผ่านมา",
    acceptance: "การยอมรับ",
    averageGuests: "เฉลี่ยผู้เข้าร่วม",
    averageGroupSize: "ขนาดกลุ่มเฉลี่ย",
    averageRevenuePerGuest: "รายได้เฉลี่ยต่อผู้เข้าร่วม",
    cancellationNoShowRevenue: "รายได้จากการยกเลิก/ไม่มา",
    charts: "กราฟ",
    graphScope: "ขอบเขตกราฟ",
    guests: "ผู้เข้าร่วม",
    guestsIn: "ผู้เข้าร่วมใน {{month}}",
    guestsLastDays: "ผู้เข้าร่วมใน {{count}} วันที่ผ่านมา",
    guestsLast30Days: "ผู้เข้าร่วมใน 30 วันที่ผ่านมา",
    guestsPerGroup: "ผู้เข้าร่วมต่อกลุ่ม",
    guestsPerReservation: "{{count}} คนต่อการจอง",
    guestsOverTime: "ผู้เข้าร่วม",
    month: "เดือน",
    newMetric: "ใหม่",
    noData: "ไม่มีข้อมูลแดชบอร์ดสำหรับตัวเลือกนี้",
    otherRevenue: "รายได้อื่น",
    pending: "รอดำเนินการ",
    pendingRequests: "รอดำเนินการ {{count}} รายการ",
    period: "ช่วงเวลา",
    previousDays: "{{count}} วันก่อนหน้า",
    previous30Days: "30 วันก่อนหน้า",
    previousMonth: "เดือนก่อนหน้า",
    rejected: "ปฏิเสธ",
    reservationRequestsOverTime: "คำขอจอง",
    revenue: "รายได้",
    revenueIn: "รายได้ใน {{month}}",
    revenueLastDays: "รายได้ใน {{count}} วันที่ผ่านมา",
    revenueLast30Days: "รายได้ใน 30 วันที่ผ่านมา",
    revenueOverTime: "รายได้",
    reservations: "การจอง",
    reservationsIn: "การจองใน {{month}}",
    reservationsLastDays: "การจองใน {{count}} วันที่ผ่านมา",
    reservationsLast30Days: "การจองใน 30 วันที่ผ่านมา",
    searchPrompt: "ข้อมูลแดชบอร์ดจะแสดงที่นี่หลังจากคลิกค้นหา",
    subtitle: "ภาพรวมประสิทธิภาพของสถานที่",
    table: "ตาราง",
    title: "แดชบอร์ด",
    total: "รวม",
    totalRequests: "คำขอทั้งหมด",
    unanswered: "ยังไม่ได้ตอบ",
    unansweredRequests: "ยังไม่ได้ตอบ {{count}} รายการ",
    week: "สัปดาห์",
    viewMode: "โหมดมุมมอง",
    windowDays: "จำนวนวัน",
    year: "ปี",
  },

  date: {
    date: "วันที่{{day}} เดือน{{month}} ปี{{year}}",
    today: "วันนี้",
    tomorrow: "พรุ่งนี้",
  },

  error: {
    [errors.invalidCredentials]: "ข้อผิดพลาด: ข้อมูลรับรองไม่ถูกต้อง",
    [errors.invalidPassword]: "ข้อผิดพลาด: รหัสผ่านไม่ถูกต้อง",
    [errors.missingCredentials]: "ข้อผิดพลาด: ขาดข้อมูลรับรอง",
    [errors.unauthorized]: "ข้อผิดพลาด: ไม่มีสิทธิ์เข้าใช้งาน",
    [errors.passwordRequestExpired]: "คำขอเปลี่ยนรหัสผ่านนี้หมดอายุแล้ว",
    [errors.passwordRequestUsed]:
      "คำขอเปลี่ยนรหัสผ่านนี้ถูกใช้งานแล้ว กรุณาตั้งรหัสผ่านใหม่อีกครั้ง",
    [errors.passwordRequestFailed]:
      "ไม่สามารถดำเนินการคำขอเปลี่ยนรหัสผ่านได้ กรุณาตั้งรหัสผ่านใหม่อีกครั้ง",
  },

  messages: {
    feedbackExplanation:
      "โปรดให้ข้อเสนอแนะเกี่ยวกับ Venue Portal หากคุณพบว่ามีสิ่งใดที่ทำให้การใช้งานไม่สะดวก ข้อเสนอแนะของคุณจะเป็นประโยชน์อย่างยิ่งในการพัฒนาระบบของเราต่อไป",
    feedbackGratitude: "ขอขอบคุณสำหรับความร่วมมือ",
    inquiryExplanation:
      "ท่านต้องการสอบถามเกี่ยวกับการจองใช่หรือไม่ หากติดต่อมายังบริษัทของเรา เราจะพยายามตอบกลับให้เร็วที่สุด",
  },

  notification: {
    empty: {
      body: "คุณไม่มีการแจ้งเตือนใหม่ในขณะนี้ โปรดกลับมาตรวจสอบอีกครั้งในภายหลัง",
      title: "ยังไม่มีการแจ้งเตือน",
    },
    feedback: {
      failedToSendFeedback: "ไม่สามารถส่งความคิดเห็นได้",
      sentFeedback: "ส่งความคิดเห็นเรียบร้อยแล้ว",
    },
    inquiry: {
      failedToSendInquiry: "ไม่สามารถส่งคำถามของคุณได้",
      sentInquiry: "การส่งคำถามเสร็จสมบูรณ์",
    },
    login: {
      failedToLogin: "ไม่สามารถเข้าสู่ระบบได้",
      loggedIn: "เข้าสู่ระบบ",
      loggedOut: "ออกจากระบบ",
    },
    password: {
      failedToSavePassword: "บันทึกรหัสผ่านไม่สำเร็จ",
      failedToSendPasswordResetEmail: "ส่งอีเมลรีเซ็ตรหัสผ่านไม่สำเร็จ",
      savedPassword: "บันทึกรหัสผ่านเรียบร้อยแล้ว",
      sentPasswordResetEmail: "ได้ส่งอีเมลรีเซ็ตรหัสผ่านแล้ว",
    },
    reservation: {
      acceptedReservation: "ยืนยันการจองเรียบร้อยแล้ว",
      failedToUpdateReservation: "ไม่สามารถแก้ไขการจองได้",
      rejectedReservation: "การจองนี้ถูกปฏิเสธ",
      resetReservation: "การจองถูกรีเซ็ต",
    },
  },

  page: {
    dashboard: "แดชบอร์ด",
    feedback: "ข้อเสนอแนะ",
    home: "หน้าหลัก",
    impersonate: "เข้าสู่ระบบแทน",
    notifications: "การแจ้งเตือน",
    settings: "การตั้งค่า",
  },

  passwordValidation: {
    confirmationPasswordMismatch: "กรุณากรอกรหัสผ่านให้ตรงกันทั้งสองครั้ง",
    passwordMinimumLength: "กรุณาตั้งรหัสผ่านให้มีอย่างน้อย 8 ตัวอักษร",
    passwordNeedsLowercase:
      "กรุณาใส่ตัวอักษรภาษาอังกฤษตัวพิมพ์เล็กอย่างน้อย 1 ตัว",
    passwordNeedsSpecialCharacter:
      "กรุณาใส่อักขระพิเศษอย่างน้อย 1 ตัว (เช่น ! / ? เป็นต้น)",
    passwordNeedsUppercase:
      "กรุณาใส่ตัวอักษรภาษาอังกฤษตัวพิมพ์ใหญ่อย่างน้อย 1 ตัว",
    passwordShould: "เกี่ยวกับข้อกำหนดของรหัสผ่าน",
  },

  reservation: {
    accepted: "ได้รับการยืนยันแล้ว",
    answeredAt: "ตอบเมื่อวันที่{{answer}} ",
    answeredAtWhen: "{{- when}}/{{answer}}",
    answeredAtWhenByWho: "ตอบเมื่อ{{- when}}โดย{{who}}:{{answer}}",
    copyGroupId: "คัดลอก ID กลุ่ม",
    endOfReservations: "ไม่มีรายการจองเพิ่มเติม",
    startOfReservations: "จุดเริ่มต้นของการจอง",
    guest: "นักท่องเที่ยว",
    guide: "ไกด์",
    noGuideAssigned: "ยังไม่ได้กำหนดไกด์",
    noReservations: "ยังไม่มีคำขอจอง",
    rejected: "ถูกปฏิเสธแล้ว",
    reservationsCount_one: "{{count}} รายการจอง",
    reservationsCount_other: "{{count}} รายการจอง",
    reservationsFrom: "การจองตั้งแต่",
    pendingReservations: "การจองที่ต้องการการตอบกลับ",
    unanswered: "ยังไม่มีการตอบกลับ",
    unconfirmedWhat: "{{what}}ยังไม่ได้รับการตอบกลับ",
    unknownGuestDetails: "ยังไม่ทราบข้อมูล",
    unknownGuides: "{{numGuides}} {{guide}}ยังไม่ยืนยัน",
    sentAt: "วันเวลาที่ส่ง",
    updateRequestedAt: "อัปเดตล่าสุดเมื่อ",
    voiceover: {
      reservationDateTimeSummary: "วันและเวลาที่ทำการจอง: {{date}} {{time}}",
      reservationInfo:
        "จำนวนผู้เข้าร่วม: {{numGuests}} {{guestLabel}}, {{numGuides}} {{guideLabel}}, ชื่อไกด์: {{guideName}}",
    },
  },

  settings: {
    mode: { dark: "โหมดมืด", light: "โหมดสว่าง" },
    languageSettings: "การตั้งค่าภาษา",
    notificationSettings: "การตั้งค่าการแจ้งเตือน",
    reservationSettings: "การตั้งค่าการจอง",
    firstDayOfWeek: "วันเริ่มต้นของสัปดาห์",
    password: {
      current: "รหัสผ่านปัจจุบัน",
      forgot: "ลืมรหัสผ่าน",
      new: "รหัสผ่านใหม่",
    },
    receiveNewReservationEmails: "รับอีเมลเมื่อมีคำขอจองใหม่",
    receiveUpdatedReservationEmails: "รับอีเมลเมื่อการจองมีการเปลี่ยนแปลง",
    receiveCancelledReservationEmails: "รับอีเมลเมื่อการจองถูกยกเลิก",
    newReservationEmailsOff:
      "คำขอจองใหม่จะแสดงใน Venue Portal เท่านั้น กรุณาตรวจสอบสม่ำเสมอเพื่อไม่ให้พลาด",
  },

  nouns: {
    all: "ทั้งหมด",
    contact: "ข้อมูลติดต่อ",
    email: "อีเมล",
    feedback: "ข้อเสนอแนะ",
    from: "จาก",
    inquiry: "ติดต่อสอบถาม",
    language: "ภาษา",
    password: "รหัสผ่าน",
    profile: "โปรไฟล์",
    MagicalTrip: "Magical Trip",
    reservation: "การจอง",
    searchMenu: "ค้นหาการจอง",
    siteName: " Venue Portal",
    theme: "ธีม",
    tour: "ทัวร์",
    until: "ถึง",
    venue: "สถานที่",
  },
};
